import React, { useState, useEffect, useContext} from 'react';
import {Form, Input, Modal, Row, Col, Button, Select} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiCross, BiPencil, BiTrash, BiX} from "react-icons/bi";
import {PostRol} from "../../../dao/root/PostRol";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import {AuthContext} from "../../../config/AuthContext";

const { Option } = Select;

interface RolModalProps {
    element: object;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
    id_usu_log : string
}

const RolAdminModal: React.FC<RolModalProps> = ({ element, visible, onClose , id_usu_log,editar}) => {
    const [form] = Form.useForm();
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    

    useEffect(() => {
        if (visible) {
            checkDades();
    }
    }, [visible]);

    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }
    async function handleSubmit () {
        const nom = await form.getFieldValue('nom');
        const id = await form.getFieldValue('id');
        const empresa = await form.getFieldValue('empresa');
        await PostRol(id, nom, empresa, id_usu_log);
        await onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Modal
            title="Crear/Editar Rol"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={'40%'}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit} >
                <br/>
                    <Form.Item 
                        label="Empresa" 
                        name="empresa" 
                        rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                    >
                        <Select
                            disabled={!editar}
                            placeholder="Selecciona una empresa"
                        >
                        {Array.isArray(empresas) && empresas.map(value =>
                            <Option key={value.id} value={value.datasource}>
                                {value.nomEmpresa}
                            </Option>
                        )}
                        </Select>
                                            
                    </Form.Item>
                <Row gutter={[16, 16]}>
                    
                    <Col span={4}>
                        <Form.Item label="id" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="nom" name="nom" 
                            rules={[{ required: true, message: 'Introdueix el nom del rol' }]}>
                            <Input type="text" />
                        </Form.Item>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default RolAdminModal;
